var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingRecipe } from "../../../../../../balancingSelectors/selectBalancingRecipes";
import { IdStyles } from "../../../../../../less/IdStyles";
import { ReplacementLoca } from "../../../../../../utils/i18n/ReplacementLoca";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { IdIcon } from "../../../../../generic/icon/IdIcon";
import { actionShowMeQuestTaskUseHumus } from "../../../../../show-me/actionShowMe";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskUseHumus = function (props) {
    var className = props.className, tasks = props.tasks, questInfoTasks = props.questInfoTasks, quest = props.quest, onTrySkip = props.onTrySkip, onClickShowMe = props.onClickShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var requiredRecipes = selectBalancingRecipe(parseInt(value.recipeIds, 10));
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentRecipesAmount = requiredInfoTask.amount || 0;
        var taskCompleted = currentRecipesAmount >= value.amount;
        var locaReplacements = new Map([
            [ReplacementLoca.target, requiredRecipes ? requiredRecipes.name : ""],
        ]);
        var icon = React.createElement(Icon, { icon: IdIcon.HumusIcn, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: currentRecipesAmount,
            icon: icon,
            locaKey: value.locaKey,
            locaReplacements: locaReplacements,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: currentRecipesAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { onClick: function () { return onClickShowMe(value); }, questTask: value })));
    });
    return (React.createElement("div", { key: "useHumus", className: className }, list));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClickShowMe: actionShowMeQuestTaskUseHumus,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskUseHumus = connect(undefined, mapDispatch)(_QuestTaskUseHumus);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskUseHumus/QuestTaskUseHumus.tsx
// module id = 2680
// module chunks = 3